module.exports = __webpack_public_path__ + "img/PT.ab6ec931.png";